module.exports = __webpack_public_path__ + "static/media/Contoh.995d901b.JPG";